export const ProposalPath = {
  PROPOSAL: 'proposal/:proposalCode',
  RENEWAL: 'renewal/:proposalCode',
  OPT_OUT: 'opt-out',
  PAYMENT: 'payment',
  UPGRADE: 'upgrade',
  DISCLOSURE: 'disclosure',
  CHECKOUT: 'checkout',
} as const

export interface ProposalParams extends Record<string, string> {
  proposalCode: string
}
